/** Props for {@link CheckCircleIcon}. */
interface CheckCircleIconProps {
  /** Icon width (default `0.875rem`). */
  width?: string;
  /** Icon height (default `0.875rem`). */
  height?: string;
  /** Stroke colour for the circle and check (default `#00897B`). */
  stroke?: string;
  /** Stroke width for the circle and check (default `1.2`). */
  strokeWidth?: string;
  /** Stroke width for the check (default `1.3`). */
  checkStrokeWidth?: string;
}

/**
 * Circled check-mark icon used to flag "Met" guidelines.
 *
 * @param props - Optional size and stroke colour overrides
 * @returns The rendered check-circle SVG
 */
export function CheckCircleIcon(props: CheckCircleIconProps) {
  const size = {
    width: props.width || "0.875rem",
    height: props.height || "0.875rem",
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size.width}
      height={size.height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clipPath="url(#clip0_19606_208327)">
        <path
          d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
          stroke={props.stroke || "#00897B"}
          strokeWidth={props.strokeWidth || "1.2"}
        />
        <path
          d="M4 7L6.5 9.5L10 5"
          stroke={props.stroke || "#00897B"}
          strokeWidth={props.checkStrokeWidth || "1.3"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_19606_208327">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
